
import React, { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';

const TrackedSection = ({ sectionName, children }) => {
  const sectionRef = useRef();
  const startTimeRef = useRef(null);
  const isVisibleRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisibleRef.current) {
          // Section just became visible
          startTimeRef.current = Date.now();
          isVisibleRef.current = true;
          console.log(`[GA4] Section "${sectionName}" entered viewport`);
        } else if (!entry.isIntersecting && isVisibleRef.current) {
          // Section just left the viewport
          const duration = Date.now() - startTimeRef.current;
          console.log(`[GA4] Section "${sectionName}" exited viewport, duration: ${duration}ms`);

          // ✅ Only send GA event if user consented to analytics
          if (window?.CookieScriptConsentGiven?.includes('analytics')) {
            ReactGA.event('section_engagement', {
                section_name: sectionName,
                time_spent_ms: duration,
              });
            console.log(`[GA4] Sent section_engagement for "${sectionName}"`);
          } else {
            console.log(`[GA4] Consent not given for analytics, skipping GA event`);
          }

          isVisibleRef.current = false;
        }
      },
      { threshold: 0.5 }
    );

    const sectionEl = sectionRef.current;
    if (sectionEl) observer.observe(sectionEl);

    return () => {
      if (sectionEl) observer.unobserve(sectionEl);
    };
  }, [sectionName]);

  return <section ref={sectionRef}>{children}</section>;
};

export default TrackedSection;

